/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
  
  connectedCallback() {
    super.connectedCallback();
    // The parent class (VariantSelects) already adds a delegated 'change' listener
    // on the variant-radios element itself. Radio 'change' events bubble, so the
    // parent listener fires once per click without any individual listeners here.
    // The previous explicit per-radio listeners were a duplicate that caused
    // onVariantChange to fire TWICE per click — doubling processVariantImages and
    // queueing two setTimeout(0) callbacks, which produced a visible jitter.
  }
}
customElements.define('variant-radios', VariantRadios);
